import React from "react";
import { MessageCircle } from "lucide-react";
import { waUrl, BOOK_MESSAGE } from "@/lib/contact";

export default function WhatsAppFloating() {
  return (
    <a
      href={waUrl(BOOK_MESSAGE())}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute -inset-2 rounded-full bg-wa/30 animate-ping" />
      <span className="relative grid place-items-center w-14 h-14 rounded-full bg-wa text-white shadow-xl hover:scale-110 transition-transform">
        <MessageCircle className="w-6 h-6" />
      </span>
      <span className="hidden md:block absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-white text-ink text-xs px-3 py-1.5 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity">
        Chat on WhatsApp
      </span>
    </a>
  );
}
